import { isMobileOnly } from 'react-device-detect';
import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    title: {
      fontSize: isMobileOnly ? 18 : 26,
      lineHeight: 1,
      // fontWeight: 700,
      fontFamily: 'var(--primary-font-bold)',
      textAlign: 'left',
      paddingRight: isMobileOnly ? '10px' : 0,
    },
    message: {
      fontFamily: '"Noto Sans", sans-serif',
      fontSize: isMobileOnly ? 12 : 16,
      fontWeight: 500,
      lineHeight: 1.5,
      textAlign: 'left',
      width: '100%',
    },
    container: {
      padding: 4,
      width: 526,
      backgroundColor: colors.black_99,
      border: '1px solid rgba(255, 255, 255, 0.25)',
      backdropFilter: 'blur(40px)',
      borderRadius: '20px',
      gap: 1,
      color: colors.white,
      alignItems: 'start',
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      gap: 2,
      width: '100%',
      justifyContent: 'end',
      alignItems: 'center',
      marginTop: 2,
    },
    secondaryButton: {
      color: colors.white,
      borderColor: colors.white,
      background: 'transparent',
      '&:hover': {
        borderColor: colors.white,
      },
    },
    close: {
      position: 'absolute',
      top: 18,
      right: 18,
      fontSize: isMobileOnly ? 16 : 12,
      color: colors.grey_200,

      cursor: 'pointer',
    },
  };
};
